import { render, staticRenderFns } from "./NetaMultiAttractionBasicDataComponent.vue?vue&type=template&id=d9c887fe&scoped=true&"
import script from "./NetaMultiAttractionBasicDataComponent.vue?vue&type=script&lang=js&"
export * from "./NetaMultiAttractionBasicDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaMultiAttractionBasicDataComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NetaMultiAttractionBasicDataComponent.vue?vue&type=style&index=1&id=d9c887fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c887fe",
  null
  
)

export default component.exports